var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "nav-bar-component" },
    [
      _c(
        "VNavigationDrawer",
        {
          staticClass: "contrast nav-drawer",
          class: { "is-mini": _vm.isMini },
          attrs: {
            touchless: "",
            clipped: "",
            permanent: "",
            floating: "",
            absolute: "",
            miniVariant: _vm.isMini
          },
          on: { transitionend: _vm.handleNavSize },
          nativeOn: {
            mouseenter: function($event) {
              return _vm.handleMouseEnter($event)
            },
            mouseleave: function($event) {
              return _vm.handleMouseLeave($event)
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "scroller flex-col" },
            [
              _c(
                "VList",
                { staticClass: "route-list py-0" },
                [
                  _c(
                    "div",
                    { staticClass: "font-light mx-3 mb-2 mt-2 menu-subtitle" },
                    [
                      _c("h3", [
                        _c(
                          "b",
                          [
                            _c("Center", [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.$store.getters.currentBucket.bucket.name
                                  ) +
                                  "\n              "
                              )
                            ])
                          ],
                          1
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "font-light mx-3 my-1 menu-subtitle" },
                    [_vm._v("\n          Global Views\n        ")]
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.routes.bucket, function(route) {
                    return _c("RouteItem", {
                      key: route.name,
                      attrs: {
                        route: route,
                        extra: {
                          params: { id: _vm.$store.state.currentBucketId }
                        }
                      },
                      on: {
                        "hover-route": _vm.onHoverRoute,
                        "leave-route": _vm.onLeaveRoute
                      }
                    })
                  }),
                  _vm._v(" "),
                  [
                    _c(
                      "div",
                      {
                        staticClass: "font-light mx-3 mt-3 mb-1 menu-subtitle"
                      },
                      [_vm._v("\n            App Views\n          ")]
                    ),
                    _vm._v(" "),
                    _c("VOverflowBtn", {
                      ref: "appSelect",
                      staticClass: "app-selector mx-3 mb-1",
                      class: {
                        "select-hidden": _vm.hasFinishedOpening === false
                      },
                      attrs: {
                        items: _vm.appNames,
                        label: "Select Application",
                        hideDetails: "",
                        editable: ""
                      },
                      on: { input: _vm.handleSelectInput },
                      model: {
                        value: _vm.appSelected,
                        callback: function($$v) {
                          _vm.appSelected = $$v
                        },
                        expression: "appSelected"
                      }
                    }),
                    _vm._v(" "),
                    _vm._l(_vm.routes.app, function(route) {
                      return _c("RouteItem", {
                        key: route.name,
                        attrs: {
                          route: route,
                          extra: { query: { app: _vm.appRouteParam } },
                          disabled: !_vm.currentFocusedApp
                        },
                        on: {
                          "hover-route": _vm.onHoverRoute,
                          "leave-route": _vm.onLeaveRoute
                        }
                      })
                    })
                  ]
                ],
                2
              ),
              _vm._v(" "),
              _vm.incentives.plus.length || _vm.incentives.enterprise.length
                ? _c("VList", { staticClass: "route-list py-0" }, [
                    _c("hr"),
                    _vm._v(" "),
                    _vm.incentives.plus.length
                      ? _c(
                          "div",
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "font-light mx-3 my-1 menu-subtitle"
                              },
                              [
                                _vm._v("\n            PM2 Plus\n            "),
                                _c(
                                  "VBtn",
                                  {
                                    attrs: { small: "", color: "primary" },
                                    on: {
                                      click: function($event) {
                                        return _vm.openPlusSubscription()
                                      }
                                    }
                                  },
                                  [_vm._v("Upgrade")]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm._l(_vm.incentives.plus, function(incentive) {
                              return _c("RouteItem", {
                                key: incentive.route.name,
                                attrs: {
                                  route: incentive.route,
                                  incentive: incentive
                                },
                                on: {
                                  "hover-route": _vm.onHoverRoute,
                                  "leave-route": _vm.onLeaveRoute
                                }
                              })
                            })
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.incentives.enterprise.length
                      ? _c(
                          "div",
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "font-light mx-3 my-1 menu-subtitle"
                              },
                              [
                                _vm._v(
                                  "\n            PM2 Enterprise\n          "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm._l(_vm.incentives.enterprise, function(
                              incentive
                            ) {
                              return _c("RouteItem", {
                                key: incentive.route.name,
                                attrs: {
                                  route: incentive.route,
                                  incentive: incentive
                                },
                                on: {
                                  "hover-route": _vm.onHoverRoute,
                                  "leave-route": _vm.onLeaveRoute
                                }
                              })
                            })
                          ],
                          2
                        )
                      : _vm._e()
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.showPortal
                ? _c(
                    "div",
                    {
                      staticClass: "base jump-to mx-3 py-3 pr-3 mt-2 mb-2",
                      on: { click: _vm.openPortal }
                    },
                    [
                      _c(
                        "div",
                        [
                          _c("KmIcon", {
                            attrs: { color: "text", name: "km-icon-jump-to" }
                          }),
                          _vm._v(" "),
                          _c(
                            "Transition",
                            {
                              attrs: {
                                name: "custom-classes-transition",
                                enterClass: "fade-start",
                                enterActiveClass: "fade",
                                enterToClass: "fade-end"
                              }
                            },
                            [
                              _vm.hasFinishedOpening === true
                                ? _c("span", { staticClass: "ml-2" }, [
                                    _vm._v(
                                      "\n              Jump to...\n            "
                                    )
                                  ])
                                : _vm._e()
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "Transition",
                        {
                          attrs: {
                            name: "custom-classes-transition",
                            enterClass: "fade-start",
                            enterActiveClass: "fade",
                            enterToClass: "fade-end"
                          }
                        },
                        [
                          _vm.hasFinishedOpening === true
                            ? _c("div", [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.shortcutText) +
                                    "\n          "
                                )
                              ])
                            : _vm._e()
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "menu-space-bellow" })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "backdrop", class: { show: !_vm.isMini } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }